document.addEventListener('DOMContentLoaded', function() {
  var nav = document.getElementById('hw-nav');
  if (nav) {
    window.addEventListener('scroll', function() {
      nav.classList.toggle('scrolled', window.scrollY > 60);
    });
  }
  document.querySelectorAll('.hw-ftab').forEach(function(tab) {
    tab.addEventListener('click', function() {
      var bar = tab.closest('.hw-filter-tabs');
      if (bar) bar.querySelectorAll('.hw-ftab').forEach(function(t){ t.classList.remove('active'); });
      tab.classList.add('active');
    });
  });
  document.querySelectorAll('.hw-dest-pill').forEach(function(pill) {
    pill.addEventListener('click', function() {
      var bar = pill.closest('.hw-dest-pills');
      if (bar) bar.querySelectorAll('.hw-dest-pill').forEach(function(p){ p.classList.remove('active'); });
      pill.classList.add('active');
    });
  });
});